import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import brandImage from "assets/img/iese-logo-navbar.png";
import ReactCountryFlag from "react-country-flag"
import { Button } from "@material-ui/core";
import ClipLoader from "react-spinners/ClipLoader";
import Axios from "axios";
import { createBrowserHistory } from "history";
import config from "assets/config/config.json";
import ExemptInside from "views/ExemptPage/ExemptPageInside";


const useStyles = makeStyles(styles);

export default function ExemptPage(props) {
    const classes = useStyles();
    const { ...rest } = props;
    const [error, setError] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [items, setItems] = React.useState(null);
    var history = createBrowserHistory();

    React.useEffect(() => {
        Axios.get(config.checklogin)
            .then(
                (_result) => {
                    Axios.get(config.getQuote)
                        .then(
                            (result) => {
                                if (!result || !result.data || !result.data.isExempt) {
                                    history.replace('/');
                                    window.location.reload();
                                } else {
                                    setItems(result.data);
                                    setIsLoaded(true);
                                }
                            },
                            (error) => {
                                setIsLoaded(true);
                                setError(error);
                            })
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(false);
                    setError(error);
                }
            )
    }, []);
    if (error && error.response && error.response.status === 403) {
        history.replace('/auth');
        window.location.reload();
        console.log('ExemptPage: Error status 403');
    }
    else if (error) {
        history.replace('/help');
        window.location.reload();
        console.log('ExemptPage: Generic error');
    }
    else if (!isLoaded) {
        console.log('ExemptPage: Not Loaded');
        return (
            <div
                style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <ClipLoader

                    size={200}
                    color={"#504a4a"}
                />
            </div>);
    }
    else {
        return (
            <div>
                <Header
                    color="dark"
                    brand={<img style={{ filter: "brightness(0) invert(1)" }}
                        src={brandImage}
                        className={classes.img}
                        alt="brand"
                    />}
                    userData={items}
                    rightLinks={
                        <div>
                            <Button className={classes.navLink}>
                                <ReactCountryFlag countryCode="ES" svg style={{
                                    height: '40px',
                                }} />
                            </Button>
                            <Button>
                                <ReactCountryFlag countryCode="GB" svg style={{
                                    height: '40px',
                                }} />
                            </Button>

                        </div>
                    }
                    fixed
                    {...rest}
                />
                <ExemptInside></ExemptInside>
            </div>

        );
    }
}